import _ from 'lodash';
import * as apiResponseMessages from '../api-response-messages';

export const UNAUTHORIZED_STATUS_CODE = 401;
const TOO_MANY_REQUESTS_STATUS_CODE = 429;
export function getServerErrorMessages(response) {
    const errorMessage = response.errorMessage;
    if (_.isEmpty(response) || _.isEmpty(errorMessage)) {
        return [apiResponseMessages.SERVER_ERROR_MESSAGE];
    }

    if (errorMessage.includes('Network error')) {
        return [apiResponseMessages.SERVER_ERROR_MESSAGE];
    }

    if (response.statusCode === UNAUTHORIZED_STATUS_CODE ||
        response.statusCode === TOO_MANY_REQUESTS_STATUS_CODE) {
        return [errorMessage];
    }

    if (_.isArray(errorMessage)) {
        return errorMessage;
    }

    if (_.isString(errorMessage) && !isTextJSON(errorMessage)) {
        return [errorMessage];
    }

    const parsedResponse = JSON.parse(errorMessage);

    if (_.isEmpty(parsedResponse) || _.isEmpty(parsedResponse.errors)) {
        return [apiResponseMessages.SERVER_ERROR_MESSAGE];
    }

    const allErrors = Object.values(parsedResponse.errors);

    return _.isEmpty(allErrors) ? [apiResponseMessages.SERVER_ERROR_MESSAGE] : allErrors;
}

function isTextJSON(text) {
    if (!_.isString(text)) {
        return false;
    }

    try {
        JSON.parse(text);
        return true;
    } catch (error) {
        return false;
    }
}
